<template>
	<m-layout>
    <div fill-height class="fill-height" style="width:100%">

      <v-card-title class="m-page__title">
        <span class="headline">Transactions</span>
          <v-btn icon class="mx-0">
             <v-icon color="primary">refresh</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
      </v-card-title>

      <v-spacer></v-spacer>

      <v-layout wrap grid-list-md>
        <v-flex xs12 class="px-1">




            <vue-csv-import v-model="csvData" :parse-config="parseConfig" :map-fields="mapFields"></vue-csv-import>


        </v-flex>
      </v-layout>
        <v-card>
          <v-card-title>
            <v-toolbar flat class="tm-toolbar">
              <v-spacer></v-spacer>
              <v-text-field
                append-icon="search"
                label="Search"
                single-line
                v-model="search_transactions"
              ></v-text-field>
          </v-toolbar>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="finalItems"
            :items-per-page="25"
            class="elevation-1"
            :footer-props="{ 'items-per-page-options': [20, 50, {text:'All', value:-1}] }"
          ></v-data-table>
        </v-card>
    </div>
	</m-layout>
</template>
<script>

//field1;field2;field3;field4;field5;field6;field7;field8;field9;field10

import { VueCsvImport } from 'vue-csv-import';
import { searchItems } from '@/utils/helpers'
import moment from 'moment';
export default {
  name: 'transactions',
  mixins: [],
  components: { VueCsvImport },
  data () {
    return {
      csvData: [],
      finalItems: [],
      search_transactions: '',
      headers: [
        { text: 'date', value: 'date' },
        { text: 'account', value: 'account' },
        { text: 'amount', value: 'amount' },
        { text: 'detail', value: 'detail' },
        { text: 'ref', value: 'ref' }
      ],
      mapFields: ['date','account','amount','detail'],

      parseConfig: {
        delimiter: ';'
      }
    }
  },
  methods: {
    getInvoiceNr (str) {
      var re = /\s([\d]{4,6})\/[\d]{1,4}/g;
      // var str = 'BE43001277073001 Communication : 000331/103 ';
      var r = re.exec(str);
      console.log('test', (r && r[1]) ? r[1] : '', r);
      return (r && r[0]) ? r[0] : '';

    }
  },
  computed: {
    filteredItems () {
      return searchItems(this.csvData, this.search_transactions);
    }
  },
  watch: {
    filteredItems (val) {
      console.log('filteredItems changed !!!', val)
      this.finalItems = val.map((item) => {
        item.ref = this.getInvoiceNr(item.detail);
        return item
      })
    }
  },
  created () {
    // this.test();
  }
}
</script>
<style lang="scss">

</style>
